// extracted by mini-css-extract-plugin
export default {"Tag":"CardProperties_Tag__CURwz","WrapperPrimaryImage":"CardProperties_WrapperPrimaryImage__rGau0","PrimaryImage":"CardProperties_PrimaryImage__SiAp1"};